import React from 'react';
import { Image } from "@heroui/react";

interface BookCoverProps {
  title?: string;
  thumbnailUrl?: string | null;
  className?: string;
  width?: number;
  height?: number;
  isZoomed?: boolean;
}

/**
 * BookCover - A reusable component for displaying book covers with fallback
 */
export default function BookCover({
  title = "Book cover",
  thumbnailUrl,
  className = "",
  width = 300,
  height = 450,
  isZoomed = true
}: BookCoverProps) {
  // Default placeholder image for when no thumbnail is available
  const defaultCoverImage = require('@/assets/images/book_cover_unavailable.webp').default.src;

  return (
    <Image
      isBlurred
      isZoomed={isZoomed}
      width={width}
      height={height}
      alt={`Okładka książki ${title}`}
      src={thumbnailUrl || defaultCoverImage}
      className={`object-cover ${className}`}
      radius='sm'
    />
  );
}